import { render, staticRenderFns } from "./GameReplay.vue?vue&type=template&id=08b5ac21&scoped=true"
import script from "./GameReplay.vue?vue&type=script&lang=js"
export * from "./GameReplay.vue?vue&type=script&lang=js"
import style0 from "./GameReplay.vue?vue&type=style&index=0&id=08b5ac21&prod&lang=scss&scoped=true"
import style1 from "./GameReplay.vue?vue&type=style&index=1&id=08b5ac21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5ac21",
  null
  
)

export default component.exports